import React from 'react';
import './Hero.scss';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          {/* Texto à esquerda */}
          <div className="hero-text">
            <h1>Chega de planilhas! Comece uma gestão profissional hoje.</h1>
            <p>Pare de perder tempo com controles manuais. Automatize sua rotina e veja seu negócio crescer com clareza.</p>
            <div className="hero-buttons">
              <a href="https://app.77gestao.com.br/cadastro?source=hero" className="btn-primary" target="_blank" rel="noopener noreferrer">
                Experimente grátis
              </a>
              <a href="/funcionalidades" className="btn-secondary">
                Ver funcionalidades
              </a>
            </div>
          </div>

          {/* Imagem à direita */}
          <div className="hero-image">
            <img 
              src="/hero.png" 
              alt="77Gestão - Sistema de Gestão ERP" 
              className="hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
